const inBackend = document.body.classList.contains('neos-backend');


/**
 * Minimizes the padding of an element in dependency of the scroll position.
 * Typically used for sticky header navs.
 */
document.querySelectorAll('.scroll-minimizer').forEach((element) => {
    const minimum = 0.3;
    const style = window.getComputedStyle(element);
    const paddingTop = parseInt(style.paddingTop);
    const paddingBottom = parseInt(style.paddingBottom);
    const paddingTotal = paddingTop + paddingBottom;
    if (!paddingTotal) return;

    const scrollFunction = () => {
        const scrollRelative = 1 - Math.min(window.scrollY / paddingTotal, 1 - minimum);

        element.style.paddingTop = `${paddingTop * scrollRelative}px`;
        element.style.paddingBottom = `${paddingBottom * scrollRelative}px`;
    };

    window.addEventListener('scroll', scrollFunction, {passive: true});
    scrollFunction();
});

/**
 * Scrolls down below the element (self) on click
 */
document.querySelectorAll('.scroll-down-self').forEach((element) => {

    if (inBackend) return;

    element.style.cursor = 'pointer';
    element.addEventListener('click', (event) => {
        event.preventDefault();

        let offset = 50;
        const dataOffset = element.dataset.scrollDownOffset;
        if (dataOffset !== undefined) {
            offset = parseFloat(dataOffset);
        }

        const marginBottom = parseFloat(window.getComputedStyle(element).marginBottom);

        window.scrollTo({
            top: element.offsetTop + element.offsetHeight + marginBottom - offset,
            behavior: 'smooth',
        });
    });
});


/**
 * Open external links in new window
 */
document.querySelectorAll('a[href^="http"], a[href^="//"]').forEach((link) => {

    if (link.getAttribute('href').includes(window.location.host)) return;

    link.setAttribute('rel', 'noopener noreferrer');
    link.setAttribute('target', '_blank');
    link.classList.add('external-link');
});
